module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-container newOrder"
  }, [_c('breadcrumb', {
    attrs: {
      "nameSection": _vm.nameSection,
      "listRoutes": _vm.listRoutes
    }
  }), _vm._v(" "), (!_vm.dataOriginal) ? _c('div', {}) : _vm._e(), _vm._v(" "), (_vm.dataOriginal) ? _c('div', {
    staticClass: "step_container"
  }, [_c('ul', {
    staticClass: "progressbar"
  }, [_c('li', {
    class: {
      inprocess: _vm.state1 === 1, active: _vm.state2 === 1 || _vm.state2 === 2
    },
    attrs: {
      "id": "li1",
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.changeFormView(1)
      }
    }
  }, [_c('p', [_vm._v("Datos del embarque")])]), _vm._v(" "), _c('li', {
    class: {
      inprocess: _vm.state2 === 1, active: _vm.state3 === 1 || _vm.state3 === 2 || _vm.dataLocal.dataShipment.status, disabled: _vm.state1 === 1 && !_vm.dataLocal.dataShipment.status
    },
    attrs: {
      "id": "li2"
    },
    on: {
      "click": function($event) {
        return _vm.changeFormView(2)
      }
    }
  }, [_c('p', [_vm._v("Agregar equipaje")])]), _vm._v(" "), _c('li', {
    class: {
      inprocess: _vm.state3 === 1, active: _vm.state4 === 1 || _vm.state2 === 1 || _vm.dataLocal.dataShipment.status, disabled: _vm.state1 === 1 && !_vm.dataLocal.dataShipment.status
    },
    attrs: {
      "id": "li3"
    },
    on: {
      "click": function($event) {
        return _vm.changeFormView(3)
      }
    }
  }, [_c('p', [_vm._v("Agregar órdenes")])]), _vm._v(" "), _c('li', {
    class: {
      inprocess: _vm.state4 === 1, active: _vm.dataLocal.dataOrder.status, disabled: (_vm.state1 === 1 || _vm.state2 === 1 || _vm.state3 === 1) && !_vm.dataLocal.dataOrder.status
    },
    attrs: {
      "id": "li4"
    },
    on: {
      "click": function($event) {
        return _vm.changeFormView(4)
      }
    }
  }, [_c('p', [_vm._v("Embarcar")])])])]) : _vm._e(), _vm._v(" "), (_vm.dataOriginal) ? _c('div', [(_vm.state1 == 1) ? _c('form1', {
    attrs: {
      "idOperator": _vm.idOperator,
      "dataLocal": _vm.dataLocal
    },
    on: {
      "toNextForm": _vm.toSecondForm,
      "saveOk": _vm.setSaveOk
    }
  }) : _vm._e(), _vm._v(" "), (_vm.state2 == 1) ? _c('form2', {
    attrs: {
      "id": _vm.dataOriginal.id,
      "dataLocal": _vm.dataLocal
    },
    on: {
      "toNextForm": _vm.toThirdForm,
      "updateListLuggage": _vm.updateListLuggage
    }
  }) : _vm._e(), _vm._v(" "), (_vm.state3 == 1) ? _c('form3', {
    attrs: {
      "id": _vm.dataOriginal.id,
      "dataLocal": _vm.dataLocal
    },
    on: {
      "go-toForm4": _vm.gotoForm4,
      "packages-saved": _vm.packagesSaved,
      "total-weight-updated": _vm.updateTotalWeight
    }
  }) : _vm._e(), _vm._v(" "), (_vm.state4 == 1) ? _c('form4', {
    attrs: {
      "id": _vm.dataOriginal.id,
      "dataLocal": _vm.dataLocal,
      "totalWeightLb": _vm.totalWeightLb
    },
    on: {
      "toSendForm": _vm.toSendForm
    }
  }) : _vm._e()], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f5f6d03"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/shipment-create-view.vue
// module id = 1851
// module chunks = 1